import { View } from 'react-native'
import { maxWidth, useMainWrapperPadding } from '@/src/common/wrappers/MainWrapper'
import { DesignSystem } from '@/src/design-system'
import { mesaColorNames, typography } from '@/src/common/theme'

export function PartnerDisclosures({ disclosureParagraphs }: { disclosureParagraphs: string[] }) {
  const mainWrapperPadding = useMainWrapperPadding()

  return (
    <View
      style={{
        width: '100%',
        paddingTop: 40,
        paddingBottom: 20,
      }}
    >
      <View
        style={{
          maxWidth,
          paddingHorizontal: mainWrapperPadding,
          marginHorizontal: 'auto',
          width: '100%',
        }}
      >
        {disclosureParagraphs.map((paragraph, index) => (
          <DesignSystem.Markdown
            key={index}
            style={{
              body: {
                ...typography.S,
                color: mesaColorNames['Greyscale/400 #A4AAAC'],
              },
            }}
            children={paragraph}
          />
        ))}
      </View>
    </View>
  )
}
